/**
 * Accordion.jsx
 * Created by michaelbray on 3/8/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import AccordionRow from './AccordionRow';
import AccordionContent from './AccordionContent';

const propTypes = {
    items: PropTypes.array
};

export default class Accordion extends React.Component {
    constructor(props) {
        super(props);

        const initialShowItems = new Array(props.items.length).fill(false);

        this.state = {
            showItems: initialShowItems
        };

        this.clickedRow = this.clickedRow.bind(this);
    }

    clickedRow(index) {
        const shownItems = this.state.showItems;

        shownItems[index] = !shownItems[index];

        this.setState({
            showItems: shownItems
        });
    }

    generateAccordionRows(items) {
        const accordionRows = [];

        items.forEach((item, index) => {
            accordionRows.push(
                <div
                    className="rec-accordion-item"
                    key={`${item.label.title}-${index}`}>
                    <AccordionRow
                        showRow={this.state.showItems[index]}
                        rowIndex={index}
                        label={item.label}
                        clickedRow={this.clickedRow} />
                    <AccordionContent
                        content={item.content}
                        showRow={this.state.showItems[index]} />
                </div>
            );
        });

        return accordionRows;
    }

    render() {
        const accordionItems = this.generateAccordionRows(this.props.items);

        return (
            <div className="rec-accordion">
                {accordionItems}
            </div>
        );
    }
}

Accordion.propTypes = propTypes;
